import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ArticleList } from '../../../pages/ArticleList'

const articleListSearchSchema = z.object({
  search: z.string().optional(),
  statuses: z.array(z.coerce.number()).optional().catch([]),
  visibilities: z.array(z.coerce.number()).optional().catch([]),
  // Collection ids; each includes its sections
  collections: z.array(z.string()).optional().catch([]),
  organizationIds: z.array(z.string()).optional().catch([]),
  featured: z.coerce.boolean().optional(),
  fromDate: z.string().optional(),
  toDate: z.string().optional(),
  sortBy: z.string().default('updatedAt'),
  sortDescending: z.coerce.boolean().default(true),
  page: z.coerce.number().default(1),
  pageSize: z.coerce.number().default(20),
})

export const Route = createFileRoute('/helpdesk/knowledge-base/')({
  component: ArticleList,
  validateSearch: articleListSearchSchema,
})